import { httpService } from "./httpService";

/**
 * Returns all scheduler_health rows, most-stale first. One row per cron job.
 * Each row has scheduler_name, last_run_at (epoch ms), last_status, last_metadata (JSON string).
 */
export const getSchedulerHealth = async () =>
  httpService({ url: "/scheduler-health", options: { method: "GET" } });
